module.exports = __webpack_public_path__ + "static/media/design3.c406c54e.png";